import { useContext } from "react";
import ThemeContext from "../ThemeContext/index";
export var useTheme = function() {
    return useContext(ThemeContext);
};
export default useTheme;
